export const Loader = ({ colorClass = "text-success", padding = "100px" }) => (
  <div
    className="justify-content-center align-items-center text-center"
    style={{ padding }}
  >
    <div className={`spinner-border ${colorClass}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
